import React from 'react';
import { useField } from 'formik';

// components
import { CheckboxInput } from 'components/inputs/CheckboxInput';

export interface CustomTextProps {
  name: string;
  id?: string;
  label: string;
  test?: any;
  value: string;
  selected: boolean;
}

export const CheckBoxField = (props: CustomTextProps) => {
  const [field] = useField(props.name);
  return <CheckboxInput {...props} {...field} value={props.value} />;
};
